import { Ajax } from "../util/base.js";
import config from "./config";
let api  = process.env.NODE_ENV === "production" ? 'https://data.shemen365.com' : 'https://data.shemen365.com'
// +++++++++++球队阵容++++++++++
export function matchPlayerList(param,params2) {
    const url = `${api}/lineup/${param.match_id}.json`;
    return Ajax(url, params2, "GET");
}
// +++++++++数据分析-三个圈++++++++++++++
export function matchTeamStatics(param,params2) {
    const url = `${api}/team-statics/${param.match_id}.json`;
    return Ajax(url, params2, "GET");
}// +++++++++数据分析-条形图 ++++++++++++++
export function matchLiveBasicListExt(param,params2) {
    const url = `${api}/team-statics/ext/${param.match_id}.json`;
    return Ajax(url, params2, "GET");
}
// ================英足总杯=============
export function matchTournamentSchedule(param,params2) {
    const url = `${api}/tournament-schedule/${param.id}.json`;
    return Ajax(url, params2, "GET");
}
// ================事件直播============
export function matchEvent(param,params2) {
    const url = `${api}/event/${param.match_id}.json`;
    return Ajax(url, params2, "GET");
}
// ============轮询赛事直播=============
export function matchTournamentLive(param) {
    const url = `${api}/tournament-schedule/live/262851.json`;
    return Ajax(url, param, "GET");  
}